import { __rest } from "tslib";
import React, { Fragment } from 'react';
import { useTheme } from '../../../../../theme';
import { useTranslation } from 'react-i18next';
import { CdnIcon, Filter } from '@shared/ui';
import { useDirections } from '../../hooks';
import DropdownDirections from '../DropdownDirections/DropdownDirections';
const DesktopDirections = ({ cities }) => {
    const { DesktopDirections: css } = useTheme('TravellerForm');
    const { t } = useTranslation('Traveller');
    const _a = useDirections(cities), { fields } = _a, model = __rest(_a, ["fields"]);
    return (React.createElement("div", { className: css.directions }, fields.map((field, index) => {
        var _a;
        return (React.createElement(Fragment, { key: field.queryFieldName },
            React.createElement("div", { className: css.field },
                React.createElement(DropdownDirections, Object.assign({}, model, { field: field, InputProps: {
                        variant: 'labelOut',
                        helperText: t('You have selected all available cities')
                    } })),
                React.createElement("div", { className: css.selectedOptions }, (_a = field.selectedOptions) === null || _a === void 0 ? void 0 : _a.map(option => (React.createElement(Filter, { key: option.value, label: option.label, isSelected: true, icon: React.createElement(CdnIcon, { icon: "Action/Close-Clear" }), onClick: () => model.deleteOption(field.arrayFieldName, option) }))))),
            index === 0 && React.createElement("div", { className: css.verticalLine })));
    })));
};
export default DesktopDirections;
